<div class="notification_container">
  <div class="pd_30 border-bottom">
    <div class="flex justify-between align-center">
      <div class="fc_DEDEDE fz_18">Notifications</div>
      <img src="./assets/images/black/close.png" class="close_image" (click)="close()">
    </div>
    <div class="text-right fz_14 mt_50">
      <div style="text-decoration-line: underline;color: rgba(222, 222, 222, 0.4);" class="cursor_pointer"
           (click)="markAllAsRead(this.notificationArray)">Mark as
        all read
      </div>
    </div>
  </div>
  <div *ngIf="notificationArray">
    <div *ngFor="let notificationItem of notificationArray; let i = index" class="notify_box fz_14 fc_DEDEDE">
      <div *ngIf="notificationItem.notificationReceivers[0].status === 0">
        <div class="flex justify-between"
           [ngClass]="{'notification-link' : notificationItem?.notificationId}"
           (click)="goToTab(notificationItem)">
          <div style="margin-right: 5px;">
            <div>{{notificationItem.title?.en}}</div>
            <div innerHTML="{{notificationItem.content?.en}}"></div>
          </div>
          <div>
            <!-- <img src="./assets/images/black/operate_000.png" class="operate_image"
                (click)="notificationItem.showBox=!notificationItem.showBox"> -->
            <div class="operate_box" style="margin: -40px 0 0 -80px;" *ngIf="notificationItem.showBox"
                 (mouseleave)="notificationItem.showBox=false">
              <div class="operate_text fz_14" (click)="handleMute(notificationItem)">Mute</div>
              <!-- <div class="operate_text fz_14">Delete</div> -->
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <div class="notification-item-date">
            {{this.notificationItem.createTime | date:'dd/MM HH:mm'}}
          </div>
        </div>
      </div>
      <!--      notification read-->
      <div *ngIf="notificationItem.notificationReceivers[0].status === 1">
        <div class="flex justify-between">
          <div style="margin-right: 5px; color: grey">
            <div>{{notificationItem.title?.en}}</div>
            <div innerHTML="{{notificationItem.content?.en}}"></div>
          </div>
          <div>
            <!-- <img src="./assets/images/black/operate_000.png" class="operate_image"
                (click)="notificationItem.showBox=!notificationItem.showBox"> -->
            <div class="operate_box" style="margin: -40px 0 0 -80px;" *ngIf="notificationItem.showBox"
                 (mouseleave)="notificationItem.showBox=false">
              <div class="operate_text fz_14" (click)="handleMute(notificationItem)">Mute</div>
              <!-- <div class="operate_text fz_14">Delete</div> -->
            </div>
          </div>
        </div>
        <div class="flex justify-end">
          <div class="notification-item-date"
               style="color: grey">
            {{this.notificationItem.createTime | date:'dd/MM HH:mm'}}
          </div>
        </div>
      </div>
    </div>

  </div>
  <div style="height: 200px;" class="flex justify-center align-center">
    <button mat-button (click)="seeAll()"
            style="width:267px;height:52px;border:1px solid #DEDEDE;border-radious: 8px; color: #DEDEDE;">See all
      Activity
    </button>
  </div>
</div>
